<template>
  <b-modal
    :active.sync="active"
    has-modal-card
    class="import-modal"
    @close="close"
  >
    <div class="modal-card" style="overflow: initial">
      <header class="modal-card-head">
        <p class="modal-card-title">
          <slot name="header">
            {{ tag ? "Update" : "Create" }} Tag
          </slot>
        </p>
      </header>
      <section class="modal-card-body" style="overflow: initial">
        <b-field label="Name">
          <b-input type="text" v-model="form.name"></b-input>
        </b-field>
        <b-field label="Type" v-if="!type">
          <base-combobox :value.sync="form.type" :service="$options.tagService" fetch-func="listTypes"
            :fetch-params="{ firm_id: firmId }" fetch-on-init label-key="type" allow-new />
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <b-button @click="close">Cancel</b-button>
        <b-button :loading="loading" @click.prevent="submit">
          Save
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import BaseCombobox from "@/components/partials/BaseCombobox";
import { TagService } from "@/services/tag.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  tagService: TagService,
  props: {
    tag: {
      type: Object
    },
    firmId: {
      type: String | Number,
      required: true
    },
    type: {
      type: String
    }
  },
  components: {
    BaseCombobox
  },
  data: () => ({
    form: {
      name: "",
      type: ""
    },
    active: false,
    loading: false
  }),
  created() {
    if (this.type) {
      this.form.type = this.type;
    }
    if (this.tag) {
      this.populateForm(this.tag);
    }
  },
  methods: {
    open() {
      this.active = true;
    },
    close() {
      this.clearForm();
      this.$emit("close");
      this.active = false;
    },
    clearForm() {
      this.form = {
        name: "",
        type: ""
      };
    },
    populateForm(tag) {
      this.form = {
        name: tag.name,
        type: tag.type
      };
    },
    async submit() {
      try {
        this.loading = true;
        if (this.tag) {
          const tag = await this.$options.tagService
            .update(this.tag.id, this.form)
            .then(response => JsonDenormalizer.denormalize(response));
          this.$emit("update", tag);
        } else {
          const tag = await this.$options.tagService
            .store({
              ...this.form,
              firm_id: this.firmId
            })
            .then(response => JsonDenormalizer.denormalize(response));
          this.$emit("create", tag);
        }
        this.close();
      } catch (err) {
        throw err;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Tag/TagFormModal.vue